import React from 'react';

const SvgDislikeIcon = () => (
    <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6 0V13L13 20L14.85 18.15L13.55 13H21V8.6L17.35 0H6ZM0 0V13H4V0H0Z"
            fill="#F7A36C"
        />
    </svg>
);

export default SvgDislikeIcon;
